import { createSlice } from "@reduxjs/toolkit";
import { loginAsync, getBalanceList } from "./actions";

import { defaultChain } from "_src/utils/chain/chainConfUtil";
import { isAppSupportedNetworkId } from "_src/utils/chain";

const { chainId = "", networkId = "" } = defaultChain();

// state数据
let initialState = {
  lng: "",
  theme: "dark",
  loginLoading: false,
  userData: {},
  balanceList: {},
  balanceListLoading: false,
  // 钱包相关数据 start
  connected: false,
  isSupportNetworkInfo: {
    show: false,
    networkId,
    chainId,
  },
  address: "",
  chainId,
  networkId,
  // 钱包相关数据 end
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.lng = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setConnected: (state, action) => {
      state.connected = action.payload;
    },
    setIsSupportNetworkAction: (state, action) => {
      state.isSupportNetworkInfo = action.payload;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
    setNetworkId: (state, action) => {
      if (action.payload) {
        const networkId = action.payload;
        state.networkId = networkId;
        state.isSupportNetworkInfo.networkId = networkId;
      }
    },
    setChainId: (state, action) => {
      if (action.payload) {
        const chainId = action.payload;
        state.chainId = chainId;
        state.isSupportNetworkInfo.chainId = chainId;
      }
    },
    clearGlobalStore: (state) => {
      state.connected = false;
      state.address = "";
      state.userData = {};
      state.isSupportNetworkInfo = {
        show: false,
        networkId,
        chainId,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loginLoading = true;
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        if (action.payload) {
          const { useData, balanceList } = action.payload;
          state.userData = useData || {}; // 账户信息
          state.balanceList = balanceList || {}; // 账户余额
        }
        state.loginLoading = false;
      })
      .addCase(loginAsync.rejected, (state) => {
        state.userData = {}; // 账户信息
        state.balanceList = {}; // 账户余额
        state.loginLoading = false;
      })
      .addCase(getBalanceList.pending, (state) => {
        state.balanceListLoading = true;
      })
      .addCase(getBalanceList.fulfilled, (state, action) => {
        if (action.payload) {
          state.balanceList = action.payload; // 账户余额
        }
        state.balanceListLoading = false;
      })
      .addCase(getBalanceList.rejected, (state) => {
        state.balanceList = {}; // 账户余额
        state.balanceListLoading = false;
      })
      .addMatcher(
        (action) => action.type.endsWith("/setNetworkId"),
        (state, action) => {
          // 不支持网络更改
          if (isAppSupportedNetworkId(action.payload)) {
            state.isSupportNetworkInfo.show = false;
          } else {
            state.isSupportNetworkInfo.show = true;
          }
        }
      );
  },
});

export const {
  setLanguage,
  setConnected,
  setIsSupportNetworkAction,
  setAddress,
  setChainId,
  setNetworkId,
  clearGlobalStore,
} = globalSlice.actions;

export default globalSlice.reducer;
